(() => {
  'use strict';

  const normalize = (value) => String(value || '')
    .trim()
    .toUpperCase()
    .replace(/\s+/g, '')
    .replace(/[‐‑–—−]/g, '-');
  const unique = (items) => [...new Map(items.map((item) => [item.url, item])).values()];

  function resultLink(candidate) {
    const link = document.createElement('a');
    link.href = candidate.url;
    link.textContent = candidate.title;
    return link;
  }

  let exactSkuIndexPromise;
  function loadExactSkuIndex() {
    if (!exactSkuIndexPromise) {
      if (!window.USAC_EXACT_SKU_INDEX_URL) return Promise.reject(new Error('Exact part index is unavailable.'));
      exactSkuIndexPromise = fetch(window.USAC_EXACT_SKU_INDEX_URL, { headers: { Accept: 'application/json' } })
        .then((response) => response.ok ? response.json() : Promise.reject(new Error('Exact part index is unavailable.')))
        .catch((error) => {
          exactSkuIndexPromise = undefined;
          throw error;
        });
    }
    return exactSkuIndexPromise;
  }

  async function findExactCandidates(query) {
    const target = normalize(query);
    const index = await loadExactSkuIndex();
    return unique((index.exactSkuToHandles?.[target] || []).map((handle) => ({
      url: '/products/' + handle,
      title: 'Part # ' + query,
    })));
  }

  function showMessage(container, message) {
    container.replaceChildren(document.createTextNode(message));
  }

  function showChoices(container, query, candidates) {
    container.replaceChildren();
    const summary = document.createElement('span');
    summary.textContent = 'Multiple matching product records were found. Choose the correct pack or configuration: ';
    container.appendChild(summary);
    candidates.slice(0, 8).forEach((candidate, index) => {
      if (index) container.appendChild(document.createTextNode(' · '));
      container.appendChild(resultLink(candidate));
    });
  }

  function attach(form) {
    if (form.dataset.usacPartSearchReady === 'true') return;
    form.dataset.usacPartSearchReady = 'true';
    const input = form.querySelector('input[name="q"]');
    const button = form.querySelector('button[type="submit"]');
    const results = form.querySelector('.usac-part-search__results');
    if (!input || !button || !results) return;

    form.addEventListener('submit', async (event) => {
      const query = input.value.trim();
      if (!query) return;
      event.preventDefault();
      button.disabled = true;
      showMessage(results, 'Checking exact manufacturer part number…');

      try {
        const candidates = await findExactCandidates(query);
        if (candidates.length === 1) {
          window.location.assign(candidates[0].url);
          return;
        }
        if (candidates.length > 1) {
          showChoices(results, query, candidates);
          return;
        }
        results.replaceChildren(document.createTextNode('No exact product match was found. '));
        const searchLink = document.createElement('a');
        const searchUrl = new URL(form.action, window.location.origin);
        searchUrl.searchParams.set('q', query);
        searchUrl.searchParams.set('type', 'product');
        searchLink.href = searchUrl.pathname + searchUrl.search;
        searchLink.textContent = 'Review scoped product search results';
        results.appendChild(searchLink);
        results.appendChild(document.createTextNode(' or request selection help.'));
      } catch (error) {
        showMessage(results, 'Part lookup is temporarily unavailable. Please try again or use the product search.');
      } finally {
        button.disabled = false;
      }
    });
  }

  document.addEventListener('DOMContentLoaded', () => {
    document.querySelectorAll('[data-usac-part-search]').forEach(attach);
  });
})();